import React, { useState, useEffect } from "react";
import "./Courses.scss";
import { FiSearch, FiChevronRight, FiPlay, FiPlus } from "react-icons/fi";
import { AiOutlinePlus, AiOutlineWallet } from "react-icons/ai";
import { Link } from "react-router-dom";
import PlaylistCard from "../../components/Playlist/PlaylistCard";

import { connect } from "react-redux";
import { fetchOwnPlaylist, getEnroleCourse } from "../../store/playList/actions";

const Courses = (props) => {
  const owned = [{ img: "/images/bg/1.webp" }, { img: "/images/bg/2.jpg" }];
  const [state, setState] = useState({
    search: "",
    searchResults: [],
  });
  const cards = [
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    // { img: "/images/bg/5.png" },
  ];
  useEffect(() => {
    props.fetchOwnPlaylist();
    props.getEnroleCourse();
  }, []);
  const handleSearch = () => {
    if (state.search) {
      let searchResults = props.ownPlaylist.filter(
        (pl) =>
          pl.title.toLowerCase().includes(state.search.toLowerCase()) ||
          pl?.created_by?.name
            ?.toLowerCase()
            ?.includes(state.search.toLowerCase()) ||
          pl?.created_by?.first_name
            ?.toLowerCase()
            ?.includes(state.search.toLowerCase()) ||
          pl?.created_by?.last_name
            ?.toLowerCase()
            ?.includes(state.search.toLowerCase())
      );
      setState({ ...state, searchResults });
    } else {
      setState({ ...state, searchResults: [] });
    }
  };
  useEffect(() => {
   if(!state.search){
    setState({ ...state, searchResults: [] });
   }
  }, [state.search])
  useEffect(()=> {
    const userType = props.profile.role;
    if(userType === "STUDENT"){
      props.getEnroleCourse();
    }
  }, []);
  return (
    <div className="Courses">
      <div className="top container">
        <form action="" className="search-form">
          <div className="search-wrapper">
            <FiSearch className="search-icon" />
            <input
              type="search"
              name=""
              id=""
              className="search-input"
              placeholder="Search "
              value={state.search}
              onChange={(e) => setState({ ...state, search: e.target.value })}
            />
            <div className="select" onClick={()=>{
              handleSearch()
            }}>
              <span>Search</span>
              {/* <FiChevronDown /> */}
            </div>
          </div>
        </form>
      </div>
      {/*  */}
      {props.profile.role === "TEACHER" && (
        <div className="create my-5 container">
          <Link
            className="create-btn shadow-sm"
            to="/create-playlist"
            style={{ textDecoration: "none" }}
          >
            <div className="center">
              <AiOutlinePlus />
            </div>
            <div className="h3">Create Playlist</div>
          </Link>
          <div className="create-btn shadow-sm">
            <div className="center">
              <AiOutlineWallet />
            </div>
            <div className="h3">Wallet</div>
          </div>
        </div>
      )}
      {/*  */}
      {/*  */}
      <div className="middle container ">
        <div className="d-flex justify-content-between my-3 border-bottom pb-3">
          <h1 className="h1 font-weight-bold text-black-50 ">My Courses</h1>
          {
            props.myEnroleCourse.length ? 
            (
              <div style={{display: "flex"}}>
                {
                  props.myEnroleCourse.map(item =>(
                    <PlaylistCard item={item.playlistId} sessionId={item.sessionId} removeButton={true} key={item._id} />
                  ))
                }
              </div>
            ) : 
            null
          }
        </div>
        {state.searchResults.length > 0 ? (
          <div className="bg-white wrapper">
            <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
              {state.searchResults.map((item, i) => (
                <PlaylistCard item={item} key={i} />
              ))}
            </div>
          </div>
        ) : (
          <div className="bg-white wrapper">
            <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
              {props.ownPlaylist.map((item, i) => (
                <PlaylistCard item={item} key={i} />
              ))}
            </div>
          </div>
        )}
      </div>

      {/*  */}
      {/*  */}
      <div className="middle container ">
        <div className="d-flex justify-content-between my-3 border-bottom pb-3">
          <h1 className="h1 font-weight-bold text-black-50 ">
            Favourite Courses
          </h1>
          {/* <Link
            className=" btn btn-link d-flex align-items-center"
            to="/category/brand-courses"
          >
            View all <FiChevronRight />
          </Link> */}
        </div>
        <div className="bg-white wrapper">
          <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
            {[].map((item, i) => (
              <div className="col" key={i}>
                <div className="card h-100 shadow-sm ">
                  <img src={`${item.img}`} className="card-img-top" alt="..." />
                  <div className="card-body">
                    <Link to="/course-detail/name" className="play">
                      <FiPlay />
                    </Link>
                    <h5 className="card-title h2 font-weight-bold ">
                      Piano For Beginners
                    </h5>
                    <div className="h3 font-weight-bold text-success mt-2 mb-3">
                      $ 500
                    </div>
                    <p className="card-text text-muted font-weight-light h5 ">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                  </div>
                  <div className="card-footer bg-white ">
                    <div className="h5 font-weight-light footer-text">
                      {" "}
                      4 Lectures | 40 hr | John Doe{" "}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <h3 className="ml-2">No favourite courses yet!</h3>
          </div>
        </div>
      </div>
      {/*  */}
      {/*  */}
      <div className="middle container ">
        <div className="d-flex justify-content-between my-3 border-bottom pb-3">
          <h1 className="h1 font-weight-bold text-black-50 ">
            Purchased Courses
          </h1>
          {/* <Link
            className=" btn btn-link d-flex align-items-center"
            to="/category/brand-courses"
          >
            View all <FiChevronRight />
          </Link> */}
        </div>
        <div className="bg-white wrapper">
          <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
            {[].map((item, i) => (
              <div className="col" key={i}>
                <div className="card h-100 shadow-sm ">
                  <img src={`${item.img}`} className="card-img-top" alt="..." />
                  <div className="card-body">
                    <Link to="/course-detail/name" className="play">
                      <FiPlay />
                    </Link>
                    <h5 className="card-title h2 font-weight-bold ">
                      Piano For Beginners
                    </h5>
                    <div className="h3 font-weight-bold text-success mt-2 mb-3">
                      $ 500
                    </div>
                    <p className="card-text text-muted font-weight-light h5 ">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                  </div>
                  <div className="card-footer bg-white ">
                    <div className="h5 font-weight-light footer-text">
                      {" "}
                      4 Lectures | 40 hr | John Doe{" "}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <h3 className="ml-2">No courses purchased yet!</h3>
          </div>
        </div>
      </div>
      {/*  */}
      {/*  */}
      {/* <div className="middle container ">
        <div className="d-flex justify-content-between my-3 border-bottom pb-3">
          <h1 className="h1 font-weight-bold text-black-50 ">
            Recently Viewed
          </h1>
          
        </div>
        <div className="bg-white wrapper">
          <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
            {[].map((item, i) => (
              <div className="col" key={i}>
                <div className="card h-100 shadow-sm ">
                  <img src={`${item.img}`} className="card-img-top" alt="..." />
                  <div className="card-body">
                    <Link to="/course-detail/name" className="play">
                      <FiPlay />
                    </Link>
                    <h5 className="card-title h2 font-weight-bold ">
                      Piano For Beginners
                    </h5>
                    <div className="h3 font-weight-bold text-success mt-2 mb-3">
                      $ 500
                    </div>
                    <p className="card-text text-muted font-weight-light h5 ">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                  </div>
                  <div className="card-footer bg-white ">
                    <div className="h5 font-weight-light footer-text">
                      {" "}
                      4 Lectures | 40 hr | John Doe{" "}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      {/*  */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  ownPlaylist: state.playlist.ownPlaylist,
  myEnroleCourse: state.playlist.myEnroleCourse,
  profile: state.profile.profile,
});

export default connect(mapStateToProps, {
  fetchOwnPlaylist,
  getEnroleCourse
})(Courses);
